import {
  ApplicationRef,
  ComponentRef,
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
  inject,
} from '@angular/core';
import { BoschUiDialogComponent } from './bosch-ui-dialog.component';
import { BoschUiDialogConfigType } from './bosch-ui-dialog.model';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BoschUiDialog {
  private readonly environmentInjector = inject(EnvironmentInjector);
  private readonly appRef = inject(ApplicationRef);
  private readonly document: Document = inject(DOCUMENT);

  get dialogRef(): ComponentRef<BoschUiDialogComponent> | null {
    return this._dialogRef;
  }
  get index(): number {
    return this._index;
  }

  private _dialogRef: ComponentRef<BoschUiDialogComponent> | null = null;
  private _index = 1000;

  hasTitle$ = new BehaviorSubject<boolean>(false);
  hasHeadline$ = new BehaviorSubject<boolean>(false);
  hasActions$ = new BehaviorSubject<boolean>(false);

  open(component: unknown, config?: BoschUiDialogConfigType): void {
    const dialogRef = createComponent(BoschUiDialogComponent, { environmentInjector: this.environmentInjector });
    this._index += 1;

    dialogRef.instance.component = component;

    if (config) {
      dialogRef.instance.config = config;
    }

    this.appRef.attachView(dialogRef.hostView);
    const dialogDOMElement = (dialogRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
    this.document.body.appendChild(dialogDOMElement);
    this._dialogRef = dialogRef;
  }

  close(): void {
    if (this._dialogRef) {
      this._dialogRef.destroy();
      this.appRef.detachView(this._dialogRef.hostView);
      this._dialogRef = null;
    }
  }
}
